/**
 * Telephony Configuration
 * =======================
 * Where the CRM finds the telephony service (telephony/server.js, port 3010).
 *
 * Served from anywhere but the developer's own machine → the same origin, path /api/telephony
 * (the tunnel routes /api/telephony/* to the service). Port 3010 is never open to the internet.
 *
 * It used to treat only hostnames containing "afikim.my" as production — the old domain. On
 * afikim-water.org every telephony screen called https://afikim-water.org:3010 directly and
 * failed (2026-10-15).
 */

const LOCAL_HOSTS = ['localhost', '127.0.0.1', '0.0.0.0', '::1', '[::1]'];

export function resolveTelephony(location) {
  const isLocal = LOCAL_HOSTS.includes(location.hostname);
  if (!isLocal) {
    return {
      TELEPHONY_URL: location.origin,
      API_BASE: `${location.origin}/api/telephony`,
      SOCKET_PATH: '/api/telephony/socket.io',
    };
  }
  return {
    TELEPHONY_URL: `${location.protocol}//${location.hostname}:3010`,
    API_BASE: `${location.protocol}//${location.hostname}:3010/api/telephony`,
    SOCKET_PATH: '/socket.io',
  };
}

const resolved = resolveTelephony(window.location);

export const TELEPHONY_URL = resolved.TELEPHONY_URL;
export const API_BASE = resolved.API_BASE;
export const SOCKET_PATH = resolved.SOCKET_PATH;

export default { TELEPHONY_URL, API_BASE, SOCKET_PATH };
